import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import {
  PhxDropdownModule,
  PhxButtonModule,
  PhxMenuButtonModule,
  PhxMenuModule,
  PhxIconModule,
  PhxBadgeModule,
  PhxBreadcrumbModule,
  PhxSkeletonModule,
  PhxMobileSelectModule,
  PhxSelectModule,
  PhxDividerModule,
  PhxTabsetModule,
  PhxIconButtonModule,
  PhxTooltipModule,
} from 'phx-core';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { SkeletonModule } from '../skeleton.module';
import { GroupsMultiSelectFilterModule } from '../groups-multi-select-filter/module';

import { PageHeaderComponent } from './page-header.component';
import { HeaderMobileMenuItemDirective } from './mobile-menu-item.directive';

const DECLARATIONS = [PageHeaderComponent, HeaderMobileMenuItemDirective];

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    SkeletonModule,
    GroupsMultiSelectFilterModule,
    PhxDropdownModule,
    PhxButtonModule,
    PhxMenuModule,
    PhxMenuButtonModule,
    PhxIconModule,
    PhxBadgeModule,
    PhxBreadcrumbModule,
    PhxSkeletonModule,
    PhxMobileSelectModule,
    PhxSelectModule,
    PhxDividerModule,
    PhxTabsetModule,
    PhxIconButtonModule,
    NzPageHeaderModule,
    NzTabsModule,
    NzIconModule,
    NzDropDownModule,
    NzSelectModule,
    NzBadgeModule,
    NzDividerModule,
    NzButtonModule,
    PhxTooltipModule,
  ],
  declarations: DECLARATIONS,
  exports: DECLARATIONS,
})
export class PageHeaderModule {}
